import React, { Component } from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import {GridList, GridTile} from 'material-ui/GridList';

class Places extends Component {
  render() {
    return (
      <MuiThemeProvider>
        <GridList>
          {this.props.places.map((place) => (
            <a href={place.link} target="_blank" key={place.image}><GridTile
              title={place.name}
              subtitle={<b>{place.neighborhood}</b>}
            >
              <img alt={place.name} src={place.image} />
            </GridTile></a>
          ))}
        </GridList>
      </MuiThemeProvider>
    );
  }
}

export default Places;



// WEBPACK FOOTER //
// ./src/Places.js